export const USER_NOT_AUTHORIZED_QUERY_STRING = "userNotAuthorized";
